import { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { logout } from "../../../utils/apiService";
import {
  LogoutContainer,
  StyledLogoutButton,
  ConfirmOverlay,
  ConfirmDialog,
  ConfirmTitle,
  ConfirmMessage,
  ConfirmButtonGroup,
  ConfirmButton,
} from "./index.styled";

const LogoutButton = () => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <LogoutContainer>
      <StyledLogoutButton onClick={() => setShowConfirm(true)}>
        <LogOut size={16} />
        התנתק
      </StyledLogoutButton>

      {showConfirm &&
        createPortal(
          <ConfirmOverlay onClick={() => setShowConfirm(false)}>
            <ConfirmDialog onClick={(e) => e.stopPropagation()}>
              <ConfirmTitle>התנתקות</ConfirmTitle>
              <ConfirmMessage>האם אתה בטוח שברצונך להתנתק?</ConfirmMessage>
              <ConfirmButtonGroup>
                <ConfirmButton $variant="confirm" onClick={handleLogout}>
                  התנתק
                </ConfirmButton>
                <ConfirmButton
                  $variant="cancel"
                  onClick={() => setShowConfirm(false)}
                >
                  ביטול
                </ConfirmButton>
              </ConfirmButtonGroup>
            </ConfirmDialog>
          </ConfirmOverlay>,
          document.body
        )}
    </LogoutContainer>
  );
};

export default LogoutButton;
